module.exports = __webpack_public_path__ + "img/certificate.fd748648.svg";